import type { Role } from "@agentry/zerovia-contracts";
import type React from "react";

export type Area = "public" | "end-user" | "tenant-admin" | "system-admin";

export type DemoConstraint = "read-only" | "rate-limited" | "watermark" | "no-persist";

export type ScreenModule = {
	id: string;
	path: string;
	area: Area;
	navGroup?: string;
	/** 左サイド上部のアイコン付きショートカット用。例: "workspace" | "storage" */
	navIcon?: "workspace" | "storage";
	label: string;
	roles: Role[];
	backing: "ZEROVIA" | "MOCK_ONLY";
	demo?: { allowed: boolean; constraints?: DemoConstraint[] };
	enabled: boolean;
	component: React.ComponentType;
};

type ScreenModuleFile = { default: ScreenModule };

const moduleFiles = import.meta.glob<ScreenModuleFile>("../modules/**/module.ts", {
	eager: true,
});

export function screenModulesFrom(files: Record<string, ScreenModuleFile>): ScreenModule[] {
	return Object.entries(files)
		.map(([source, file]) => ({ source, module: file.default }))
		.sort((a, b) => a.source.localeCompare(b.source))
		.map(({ module }) => module);
}

export function enabledScreenModules(modules: readonly ScreenModule[]): ScreenModule[] {
	return modules.filter((module) => module.enabled);
}

export const SCREEN_MODULES = screenModulesFrom(moduleFiles);
